module.exports = __webpack_public_path__ + "static/media/hamburger.b4bf95b9.jpg";